import { useState } from "react";
import { DotLegalAlert, DotLegalDialog, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";

export interface IRescanWithGuidanceDialogProps {
    onDialogClose: () => void;
    onRescan: (guidance: string) => void;
}

function RescanWithGuidanceDialog(props: IRescanWithGuidanceDialogProps) {
    const { translateString } = useTranslation();
    const [guidance, setGuidance] = useState("");

    return (
        <DotLegalDialog
            open
            size="sm"
            header={translateString("obligationExtractionScanAgain")}
            buttonOkText={translateString("obligationExtractionScanAgain")}
            // The run is deterministic, so a scan with nothing typed pays for a second model call, discards
            // every edit and hands back the identical obligations. Guidance is what makes it worth anything.
            okButtonDisabled={guidance.trim() === ""}
            buttonOkHoverText={translateString("obligationExtractionGuidanceRequiredTooltip")}
            onOkClick={() => props.onRescan(guidance.trim())}
            onDialogClose={props.onDialogClose}
            // A typed message is work the user would not expect a stray backdrop click to bin.
            disableBackdropOnCloseIfValueChange={guidance}
        >
            <DotLegalAlert severity="warning" warningText={translateString("obligationExtractionScanAgainTooltip")} marginTop={0} marginBottom={1} />

            <DotLegalTextField
                label={translateString("obligationExtractionGuidanceLabel")}
                value={guidance}
                onChange={setGuidance}
                placeholder={translateString("obligationExtractionGuidancePlaceholder")}
                multiline
                rows={3}
                maxLength={500}
                debounce={false}
                autoFocus
            />
        </DotLegalDialog>
    );
}

export default RescanWithGuidanceDialog;
